interface OrgSettingKeys {
  latestAccountBalanceReset: string;
  sendEmailFromUser: string;
  systemEmailDomain: string;
  /** Legacy BOL terms — read fallback only; edit via BOL_DOCUMENT_CONFIG. */
  termsAndConditions: string;
  unifiedOrderIdentifiers: string;
  invoiceCompactFooter: string;
  invoiceHideProductFamily: string;
  physicalCheckLayout: string;
  /** When "true", print "Pay to the Order of" on the check PDF. Absent = omit (opt-in). */
  physicalCheckShowPayToOrderOf: string;
  statementDisplayRemitInstructions: string;
  defaultVariablePricingLock: string;
  invoiceDocumentUseInvoiceNumber: string;
  /** When true, org uses Plaid sandbox API + credentials (demo orgs on prod deploy). */
  plaidSandboxMode: string;
  /**
   * Super-admin only. JSON array of enabled opt-in order document slugs (SC-2163).
   * @see shared/documents/order-document-settings.ts, order-menu-document-extensions/registry.ts
   */
  orderDocumentsEnabled: string;
  /** JSON OcDocumentConfig for sales order confirmation PDF (SC-2345). */
  ocDocumentConfig: string;
  /** Always-on BOL PDF customization (SC-2343). Not opt-in slug framework. */
  bolDocumentConfig: string;
  /** SO Create Packing Slip PDF customization (SC-2489). */
  packingSlipDocumentConfig: string;
  /** SO Warehouse Release v3 PDF custom header/footer (SC-2489). */
  warehouseReleaseDocumentConfig: string;
  /** Larger logo on all generated PDFs (~v1 size) (SC-2494). */
  documentsUseLargeLogo: string;
  /** JSON InvoiceDocumentConfig — invoice + proforma PDF options (SC-2494). */
  invoiceDocumentConfig: string;
  /** JSON PickUpRequestDocumentConfig — SO pick up request PDF (SC-2494). */
  pickUpRequestDocumentConfig: string;
  /** Plain-text starting notes for new international shipments. */
  defaultBorderCrossingNotes: string;
  /**
   * Warn before confirming a Sales Order with no CSR (SC-2781).
   * Unlike every other boolean key here, this one is **default ON** — an absent row means
   * enabled, and only the literal `"false"` disables it.
   * @see `~/shared/orders/csr-confirmation-setting.ts` — the only place that inversion is parsed.
   */
  requireCsrAcknowledgmentOnConfirm: string;
}

export const orgSettingKeys: OrgSettingKeys = {
  latestAccountBalanceReset: "LATEST_ACCOUNT_BALANCE_RESET",
  sendEmailFromUser: "SEND_EMAIL_FROM_USER",
  systemEmailDomain: "SYSTEM_EMAIL_DOMAIN",
  termsAndConditions: "TERMS_AND_CONDITIONS",
  unifiedOrderIdentifiers: "UNIFIED_ORDER_IDENTIFIERS",
  invoiceCompactFooter: "INVOICE_COMPACT_FOOTER",
  invoiceHideProductFamily: "INVOICE_HIDE_PRODUCT_FAMILY",
  physicalCheckLayout: "PHYSICAL_CHECK_LAYOUT",
  physicalCheckShowPayToOrderOf: "PHYSICAL_CHECK_SHOW_PAY_TO_ORDER_OF",
  statementDisplayRemitInstructions: "STATEMENT_DISPLAY_REMIT_INSTRUCTIONS",
  defaultVariablePricingLock: "DEFAULT_VARIABLE_PRICING_LOCK",
  invoiceDocumentUseInvoiceNumber: "INVOICE_DOCUMENT_USE_INVOICE_NUMBER",
  plaidSandboxMode: "PLAID_SANDBOX_MODE",
  orderDocumentsEnabled: "ORDER_DOCUMENTS_ENABLED",
  ocDocumentConfig: "OC_DOCUMENT_CONFIG",
  bolDocumentConfig: "BOL_DOCUMENT_CONFIG",
  packingSlipDocumentConfig: "PACKING_SLIP_DOCUMENT_CONFIG",
  warehouseReleaseDocumentConfig: "WAREHOUSE_RELEASE_DOCUMENT_CONFIG",
  documentsUseLargeLogo: "DOCUMENTS_USE_LARGE_LOGO",
  invoiceDocumentConfig: "INVOICE_DOCUMENT_CONFIG",
  pickUpRequestDocumentConfig: "PICK_UP_REQUEST_DOCUMENT_CONFIG",
  defaultBorderCrossingNotes: "DEFAULT_BORDER_CROSSING_NOTES",
  requireCsrAcknowledgmentOnConfirm: "REQUIRE_CSR_ACKNOWLEDGMENT_ON_CONFIRM",
};
